// extracted by mini-css-extract-plugin
export default {"message-in":"ImageMessage_message-in__F4GIl","message-out":"ImageMessage_message-out__HsuuE"};